import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=3f6d74d2&scoped=true&"
import script from "./DropdownMenu.vue?vue&type=script&lang=js&"
export * from "./DropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./DropdownMenu.vue?vue&type=style&index=0&id=3f6d74d2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6d74d2",
  null
  
)

export default component.exports